




































import Vue from "vue";
import Component from "vue-class-component";
import HomeHowItWorksTabs from "./HomeHowItWorksTabs.vue";
import SectionLayout from "../../SectionLayout.vue";
import HomeIdeasPlaceKnowMore from "../HomeIdeasPlace/HomeIdeasPlaceKnowMore.vue";

@Component({
  components: {
    HomeHowItWorksTabs,
    HomeIdeasPlaceKnowMore,
    SectionLayout
  }
})
export default class HomeHowItWorks extends Vue {
  showKnowMore: boolean = false;

  toggleKnowMore() {
    this.showKnowMore = !this.showKnowMore;
  }
}
